import { useaxios } from "../../../../utils/useaxios";
export default (daily_expense_amount, daily_expense_type, daily_expense_location, daily_expense_date, daily_expense_note) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('daily_expense/create.php', { daily_expense_amount, daily_expense_type, daily_expense_location, daily_expense_date, daily_expense_note, department_id: 4 }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}